import { Injectable } from '@angular/core';

interface Breadcrumbs {
  title : string,
  url? : string,
  function?: string
}

@Injectable()
export class AdminBreadcrumbService {
  public links : Array<Breadcrumbs>  = [];
  private _title : string = '';
  private _count : number = 0;
  constructor() { 
    
  }

  clear() {
    this.links = [];
  }

  set addcrumb(crumb : Breadcrumbs) {
    this.links.push(crumb);  
  }

  set count(number : number) {
    this._count = number;
  }

  get count() : number {
    return this._count;
  }

  get crumbs(): Array<Breadcrumbs> {
    return this.links;
  }

  set mobiletitle(title : string) {
    this._title = title;
  }

  get mobiletitle() : string {
    return this._title;
  }

}
